const rules = {

  utils: {
    bodyData() {
      return $('body').data();
    }
  },

  account() {
    return this.utils.bodyData().isUserSignedIn;
  },

  confirmed_account() {
    return this.utils.bodyData().isUserEmailConfirmed;
  },

  subscription() {
    return this.utils.bodyData().isUserSubscribed;
  },

  premium() {
    return this.utils.bodyData().isUserPremium;
  }

};

export default rules;
